import { isInPremiumSupportTreatmentFlight } from 'owa-premium-support';
import persistFlightStatus from '../mutators/persistFlightStatus';

export default async function getPremiumSupportFlightStatus() {
    persistFlightStatus(await isInPremiumSupportTreatmentFlight());
}
